export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8014.92c7ab99.jpg";